import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import ContentWidth from "components/ContentWidth"
import StyledLink from "components/StyledLink"

const Cards = ({ cardData }) => {
  const allCards = cardData?.cards?.map(card => (
    <CardLink href={card?.linkUrl}>
      <Card cardVariation={cardData.variation}>
        {card?.cardImage && (
          <CardImage
            cardVariation={cardData?.variation}
            src={card?.cardImage?.sourceUrl}
            alt={card?.cardImage?.altText}
          />
        )}
        {card?.gradientHeader && (
          <GradientHeader>{card?.gradientHeader}</GradientHeader>
        )}
        <ContentDiv cardVariation={cardData.variation}>
          {card?.eyebrow && (
            <CardEyebrow $unstyled={card?.unstyled}>
              {card?.eyebrow}
            </CardEyebrow>
          )}
          {card?.header && <CardHeader>{card?.header}</CardHeader>}
          {card?.bodyCopy && <CardCopy>{card?.bodyCopy}</CardCopy>}
          {card?.linkUrl && (
            <StyledLink bottom href={card?.linkUrl}>
              {card?.linkText}
            </StyledLink>
          )}
        </ContentDiv>
      </Card>
    </CardLink>
  ))

  return (
    <ContentWidth>
      <Wrapper>
        <CardsDiv cardVariation={cardData?.variation}>{allCards}</CardsDiv>
      </Wrapper>
    </ContentWidth>
  )
}

const CardLink = styled.a``
const CardCopy = styled.p`
  ${text.bodyMd};
  color: ${colors.grey800};
`
const CardHeader = styled.h5`
  ${text.h5};
  color: ${colors.grey800};

  ${media.mobile} {
    ${text.h4};
  }
`
const CardEyebrow = styled.p`
  ${props => (props.$unstyled ? `${text.bodyMd}` : `${text.eyebrow}`)};

  color: ${props =>
    props.$unstyled ? `${colors.black}` : `${colors.gray500}`};
`
const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 1.111vw;
  padding: 1.111vw 1.111vw 1.667vw 1.111vw;

  ${media.fullWidth} {
    gap: 16px;
    padding: 16px 16px 24px 16px;
  }

  ${media.tablet} {
    gap: 1.563vw;
    padding: 1.563vw;
  }

  ${media.mobile} {
    gap: 3.738vw;
    padding: 3.738vw 3.738vw 5.607vw 3.738vw;
  }
`
const GradientHeader = styled.p`
  ${text.h2};
  ${text.transparentText};
  background-image: ${colors.purpleGradient};
  margin: 4.861vw 0 1.736vw 1.111vw;

  ${media.fullWidth} {
    margin: 70px 0 25px 16px;
  }

  ${media.tablet} {
    ${text.h3};
    margin: 6.836vw 0 1.27vw 1.563vw;
  }

  ${media.mobile} {
    margin: 16.355vw 16.589vw 16.355vw 3.738vw;
  }
`
const CardImage = styled.img`
  width: 100%;
  height: ${props =>
    props.cardVariation === "3-Card" ? "16.181vw" : "13.889vw"};

  ${media.fullWidth} {
    height: ${props => (props.cardVariation === "3-Card" ? "233px" : "200px")};
  }

  ${media.tablet} {
    height: 19.141vw;
  }

  ${media.mobile} {
    height: 57.71vw;
  }
`
const Card = styled.div`
  display: flex;
  flex-flow: column;
  overflow: hidden;
  width: ${props =>
    props.cardVariation === "3-Card" ? "24.583vw" : "21.181vw"};
  height: 100%;
  border-radius: 0.972vw;
  box-shadow: 0vw 0.278vw 0.278vw 0vw rgba(0, 0, 0, 0.1);
  background-color: ${colors.white};

  ${media.hover} {
    &:hover {
      scale: 1.055;
      transition-duration: 0.5s;
      cursor: pointer;
    }
  }

  ${media.fullWidth} {
    width: ${props => (props.cardVariation === "3-Card" ? "354px" : "305px")};
    border-radius: 14px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  }

  ${media.tablet} {
    width: ${props =>
      props.cardVariation === "3-Card" ? "29.297vw" : "22.949vw"};
    border-radius: 1.367vw;
    box-shadow: 0vw 0.391vw 0.391vw 0vw rgba(0, 0, 0, 0.1);
  }

  ${media.mobile} {
    width: 87.85vw;
    border-radius: 3.271vw;
    box-shadow: 0vw 0.935vw 0.935vw 0vw rgba(0, 0, 0, 0.1);
  }
`
const CardsDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5.556vw;
  gap: ${props => (props.cardVariation === "3-Card" ? "2.847vw" : "1.389vw")};

  ${media.fullWidth} {
    margin-bottom: 80px;
    gap: ${props => (props.cardVariation === "3-Card" ? "41px" : "20px")};
  }

  ${media.tablet} {
    margin-bottom: 5.859vw;
    gap: ${props => (props.cardVariation === "3-Card" ? "2.148vw" : "0.977vw")};
  }

  ${media.mobile} {
    flex-direction: column;
    margin-bottom: 9.346vw;
    gap: ${props => (props.cardVariation === "3-Card" ? "9.579vw" : "4.673vw")};
  }
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
`
export default Cards
